import { connect } from "react-redux";
import { sendVerification, checkVerification } from "../../../actions/verify_actions";
import ScheduleModal from './schedule_appointment_modal';

const mSTP = (state, ownProps) => {
  return {
    config: state.config,
    appointments: state.appointments,
    first_available: state.first_available,
    verify: state.verify
  };
};

const mDTP = dispatch => ({
  checkVerification: data => dispatch(checkVerification(data)),
  sendVerification: data => dispatch(sendVerification(data))
});

export default connect(mSTP, mDTP)(ScheduleModal);
